// WMO weather interpretation codes — https://open-meteo.com/en/docs
export function weatherCodeLabel(code: number): string {
  if (code === 0)  return 'Clear';
  if (code === 1)  return 'Mainly clear';
  if (code === 2)  return 'Partly cloudy';
  if (code === 3)  return 'Overcast';
  if (code === 45 || code === 48) return 'Fog';
  if (code >= 51 && code <= 57) return 'Drizzle';
  if (code >= 61 && code <= 67) return 'Rain';
  if (code >= 71 && code <= 77) return 'Snow';
  if (code >= 80 && code <= 82) return 'Rain showers';
  if (code >= 85 && code <= 86) return 'Snow showers';
  if (code >= 95 && code <= 99) return 'Thunderstorm';
  return '—';
}

export function weatherCodeEmoji(code: number, isDay: boolean = true): string {
  if (code === 0)  return isDay ? '☀️' : '🌙';
  if (code === 1)  return isDay ? '🌤️' : '🌙';
  if (code === 2)  return isDay ? '⛅' : '☁️';
  if (code === 3)  return '☁️';
  if (code === 45 || code === 48) return '🌫️';
  if (code >= 51 && code <= 57) return '🌦️';
  if (code >= 61 && code <= 67) return '🌧️';
  if (code >= 71 && code <= 77) return '❄️';
  if (code >= 80 && code <= 82) return '🌧️';
  if (code >= 85 && code <= 86) return '🌨️';
  if (code >= 95 && code <= 99) return '⛈️';
  return '—';
}
